var bannersSampleSlider = {
	
	init : function(){ 
		var banners_slider = $('.sample-banner-carousel').slick({
            dots: false,
            arrows:false,
            nav:false,
            infinite: false, 
            speed: 300,
            slidesToShow: 1 
        });

       
        $('.sample-banner .right').click(function(){ $('.sample-banner .left').click(function(){
            banners_slider.slick('slickPrev');
            return false;
        });
            banners_slider.slick('slickNext');
            return false;
        });
	}	
};  


var accountNavSlider = {

    init : function(){ 
        var  initial_slide = $('.account-nav-item a.active').parent().index();
        $('.account-nav').attr('data-index',initial_slide);

        var account_slider = $('.account-nav-slider').slick({
            dots:           false,
            arrows:         false,
            nav:            false,
            infinite:       true, 
            speed:          300,            
            edgeFriction:   0,
            variableWidth:  true,
            slidesToShow:   $('.account-nav-item').length,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow:4,
                        initialSlide:  initial_slide,
                        centerMode: false, 
                        infinite:false,
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow:3,
                        centerMode: true, 
                        infinite:true,
                        initialSlide:  initial_slide,
                    }
                }
            ]
        });

        account_slider.on('afterChange', function(){
            var index = Number($('.account-nav-slider .slick-slide.slick-active').data('slick-index'))+1;        
            $('.account-nav').attr('data-index',index);
        });

    }    
};  
 
var inventoryListSlider = {

 
    init : function(){ 
        $( ".inventory-tr-slider" ).each(function( index ) {
        if(!$(this).hasClass("slick-initialized")){
                var inventory_slider = $(this).slick({
                    dots: false,
                    arrows:false,
                    nav:false,
                    infinite: false, 
                    speed: 300,
                    asNavFor: '.inventory-tr-slider',
                    variableWidth: true,
                    slidesToShow:7,
                    responsive: [
                        {
                          breakpoint:1400,
                          settings: {
                            variableWidth: false,
                          }
                        },
                        {
                          breakpoint:1200,
                          settings: {
                            slidesToShow:5,
                            variableWidth: true,
                          }
                        },
                        {
                          breakpoint:992,
                          settings: {
                            slidesToShow:4,
                            variableWidth: true,
                          }
                        },
                        {
                          breakpoint: 768,
                          settings: {
                            slidesToShow:3,
                          }
                        },
                        {
                              breakpoint: 480,
                              settings: {
                                slidesToShow:2,
                              }
                        }
                    ]
                });
            }
        });
    }   
};  

var profileEdit = { 
	
	init : function(){
		$('.widget.profile .nav-tabs a').click(function(){
			var label = $(this).data('label');
			$('.widget.profile .nav-trigger span').html(label);
			$('.widget.profile .widget-content .nav-tabs').removeClass('open');
		});
		$('.widget.profile .nav-trigger').click(function(e){
			$('.widget.profile .widget-content .nav-tabs').toggleClass('open');
			e.preventDefault();
		});
	},

    disconnectAccount : function($this){
        $.ajax({
            type: "POST",
            url: "/api/disconnect-social-account",
            data: {
                provider: $this.data('provider')
            },
            success:function(data){
                window.location.reload();
            }
        });
        return false;
    }
};

var UsersReviews = {
	init : function(){
		$('.my_reviews_grid .review_item .btn-delete').click(function(){
            if(confirm('Are you sure?')){
                UsersReviews.deleteSelectedReview($(this));
            }
			return false;
		});
	},
	deleteSelectedReview : function($this){

		$.ajax({
			type: "POST", 
			url: "/api/delete-selected-review", 
			data: { 
				id: $this.data('id')
			},
			success:function(data){
                window.location.reload();
            }
		});
	}
};


var UserAvatar = {
    avatar : null,
    init : function(target){

        var $this = this;

        $('#'+target + '-save').on('click',function(){
            if($this.avatar != null){
                $.ajax({
                    type: "POST",
                    url: "/api/upload-avatar",

                    data: {
                        avatar: $this.avatar
                    },
                    success:function(data){
                       window.location.reload();
                    }
                });
            }else{
                alert('select an image first');
            }
        })

        $('#'+target).closest('.modal').one('shown.bs.modal',function(){

            var uploader = new plupload.Uploader({
                runtimes        : 'html5,flash,silverlight,browserplus',
                browse_button   : target + '-pickfiles',
                container       : target + '-container',
                drop_element    : target + '-dropzone',
                url             : UPLOAD_URL,
                headers:{
                    'X-CSRF-TOKEN':$('meta[name="csrf-token"]').attr('content')
                },
                multipart_params: {
                    'key': 'tmp/'+ USER_ID +'/${filename}', 
                    'Filename': '${filename}', 
                    'success_action_status':'201',
                    'acl': 'public-read',
                    "Content-Type": "image/*",
                    'AWSAccessKeyId' : S3_ACCESS_KEY,
                    'policy': S3_POLICY,
                    'signature': S3_SIGNATURE
                },
                filters : {
                    max_file_size : '3mb',
                    mime_types: [
                        {title : "Images", extensions : "jpg,jpeg,png"}
                    ]
                }
            });

            $('#'+target + '-uploadfiles').click(function(e) {
                uploader.start();
                e.preventDefault();
            });

            uploader.init();

            uploader.bind('FilesAdded', function(up, files) {

                $.each(files, function(i, file) {
                    var markup = '	<div id="' + file.id + '"><p style="    text-overflow: ellipsis;overflow: hidden;">'+file.name+'<br/>' + plupload.formatSize(file.size) + '</p>\
                                    <div class="progress progress-small" style="display:none;height:6px;">\
                                        <div class="progress-bar progress-bar-danger" style="    background-color: rgb(34, 137, 233);width: 0%;"></div>\
                                    </div>';
                    $('#'+target + '-uploaded-files').html(markup);
                });
                up.refresh();

                uploader.start();
            });

            uploader.bind('UploadProgress', function(up, file) {
                $('#' + file.id + " .progress").fadeIn('fast');
                $('#' + file.id + " .progress .progress-bar").width(file.percent + "%");
            });

            uploader.bind('Error', function(up, err) {

                AjaxForms.form_submit_response("Message: " + err.message + (err.file ? ", File: " + err.file.name : "") ,'error');
                up.refresh();

            });

            uploader.bind('FileUploaded', function(up, file,ee) {
                $('#' + target + '-dropzone').css("background", "transparent url('"+UPLOAD_URL  +'tmp/'+ USER_ID +'/'+file.name+"') no-repeat 50% 50%");
                $('#' + target + '-dropzone').css("background-size", "cover");


                $('#' + file.id + " .progress").fadeOut('fast');
                $('.user-avatar input[name="profile[avatar]"]').val('tmp/'+ USER_ID +'/'+file.name);

                $this.avatar = file.name;


            });
        })


    },
    deleteSelectedPriceAlert : function($this){
        $.ajax({
            type: "POST",
            url: "/api/upload-avatar",
            data: {
                avatar: $this.data('id')
            },

            success:function(data){
                load_partial($this.closest('.partial'));
            }
        });
    },
    deleteAllPriceAlerts : function(){
        $.ajax({
            type: "POST",
            url: "/api/delete-all-price-alerts",

            data: {
                id: 'all'
            },
            success:function(data){
                load_partial($this.closest('.partial'));
            }
        });
        return false;
    }
};

var accountSearchForm = function(form) {
    $(form).parsley();
    $(form).on('submit',function($e){   
        var $q = $(form + ' input[name="q"]').val();
        $(form).closest('.partial').data('q', $q);
        load_partial($(form).closest('.partial'));
        return false;       
    });
};

var editUsersForm = function() {
    $('.users-item-save').click(function(){        
        $(this).closest('.user-item').find('.hidden-on-edit').addClass('hidden');
        $(this).closest('.user-item').find('.visible-on-edit').removeClass('hidden');
        return false;
    });  
};

